import { handleActions } from '@gef-ui/utils/fsaActions';
import { actionTypes } from '../constants';
const saveCduUser = (_state, { payload })=>payload;
export default handleActions({
    [actionTypes.SAVE_CDU_USER]: saveCduUser
}, {});
